import './trailingSlash.js'
import './features.css'
import { initSiteHeader } from './siteHeader'
import { initSiteFooter } from './siteFooter'

initSiteHeader()
initSiteFooter()
